<div style="width: 100%; font-family: Roboto, 'Helvetica Neue', sans-serif; padding: 16px; box-sizing: border-box;">
  <form [formGroup]="form">
    <!-- <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; align-items: center; background-color: white; padding: 15px; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);"> -->
      <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; align-items: center; background-color: white; padding: 15px; border-radius: 4px; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);">
      <div style="flex: 1; min-width: 200px;">
        <ng-select
          [items]="clients"
          bindLabel="ClientDescription"
          bindValue="Client"
          placeholder="Select Client"
          formControlName="client"
          [disabled]="isLoading"
          (change)="onClientChange()">
        </ng-select>
      </div>

      <div style="flex: 1; min-width: 200px;">
        <ng-select
          [items]="projects"
          bindLabel="projectCode"
          bindValue="projectCode"
          placeholder="Select Project"
          formControlName="project"
          [disabled]="!form.get('client').value || isLoading"
          (change)="onProjectChange()">
          <ng-template ng-label-tmp let-item="item">
            {{ item.projectCode }} - {{ item.projectDescription || item.project }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.projectCode }} - {{ item.projectDescription || item.project }}
          </ng-template>
        </ng-select>
      </div>

      <div style="flex: 1; min-width: 100px;">
        <ng-select
          [items]="invoiceNumbers"
          bindLabel="Invoice_Number"
          bindValue="Invoice_Number"
          placeholder="Select Invoice"
          formControlName="invoice_number"
          [disabled]="!form.get('project').value || isLoading"
          (change)="onInvoiceNumberChange()">
        </ng-select>
      </div>

      <button (click)="updateInvoiceDetails()" [disabled]="!isUpdateEnabled || isLoading"
        [style.background-color]="!isUpdateEnabled || isLoading ? '#e2e8f0' : '#f0f4f8'"
        [style.color]="!isUpdateEnabled || isLoading ? '#a0aec0' : '#3182ce'"
        [style.cursor]="!isUpdateEnabled || isLoading ? 'not-allowed' : 'pointer'"
        style="border: none; border-radius: 4px; padding: 0 16px; height: 40px; font-weight: 500;">
        Update Invoice
      </button>
    </div>

    <!-- Material Tabs replacing the custom tabs -->
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">
      <mat-tab label="Invoice Details">
        <div style="padding: 16px; background-color: white;">
          <div style="display: flex; flex-direction: column; gap: 12px;">
            <div>
              <label for="invoice_description" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Invoice Description</label>
              <input type="text" id="invoice_description" formControlName="invoice_description"
                [disabled]="!form.get('invoice_number').value || isLoading" placeholder="Enter invoice description"
                style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
            </div>

            <div style="display: flex; gap: 12px;">
              <div style="flex: 1;">
                <label for="invoice_date" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Invoice Date</label>
                <input type="date" id="invoice_date" formControlName="invoice_date"
                  [disabled]="!form.get('invoice_number').value || isLoading"
                  style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
              </div>

              <div style="flex: 1;">
                <label for="bank_name" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Bank</label>
                <input type="text" id="bank_name" [value]="bankDetails?.BankName || ''"
                  readonly
                  style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; background-color: #f8f9fa; cursor: not-allowed; box-sizing: border-box;"
                  placeholder="Bank information not available">
              </div>
            </div>

            <div style="display: flex; gap: 12px;">
              <div style="flex: 1;">
                <label for="po_number" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Purchase Order Number</label>
                <input type="text" id="po_number" formControlName="po_number"
                  [disabled]="!form.get('invoice_number').value || isLoading" placeholder="Enter purchase order number"
                  style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
              </div>

              <div style="flex: 1;">
                <label for="invoice_contact" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Invoice Contact</label>
                <input type="text" id="invoice_contact" formControlName="invoice_contact"
                  [disabled]="!form.get('invoice_number').value || isLoading" placeholder="Enter invoice contact"
                  style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
              </div>
            </div>

            <div>
              <label for="invoice_address" style="display: block; margin-bottom: 4px; font-weight: 500; color: #4a5568;">Invoice Contact Address</label>
              <textarea id="invoice_address" formControlName="invoice_address" rows="4"
                [disabled]="!form.get('invoice_number').value || isLoading" placeholder="Enter invoice address"
                style="width: 100%; padding: 8px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 14px; height: 100px; resize: vertical; box-sizing: border-box;"></textarea>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Report Viewer">
        <div style="padding: 16px;">
          <iframe *ngIf="reportUrl" [src]="reportUrl" width="100%" height="500px" style="border: none; border-radius: 4px;"></iframe>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
